<template>
    <div class="activites">
      <div>
        <img src="@/assets/activites/head.png">
      </div>
      <van-list v-model="loading" @load="getGoodsList" :finished="finished">
        <goodsList :list="goodsData"></goodsList>
      </van-list>
    </div>
</template>
<script>
import { getpromotionGoods } from '@/api/goods';
import { Dialog, List } from 'vant';
import { goodsList } from './components';
export default {
  components: {
    goodsList,
    [List.name]: List
  },
  data() {
    return {
      loading: false,
      finished: false,
      page: 0,
      goodsData: []
    }
  },
  methods: {
    async getGoodsList () {
      const pId = this.$route.query.pId
      this.page++
      this.loading = true
      const result = await getpromotionGoods({
        promotion_id: pId,
        page: this.page,
        size: 8
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
      this.loading = false
      const promotion = result.data.data.promotionInfo.promotion
      // 判断活动是否结束
      if (result.data.data.status && (promotion.is_show === 0 && promotion.is_start === 0)) {
        this.finished = true
        Dialog.alert({
          title: '当前活动已结束',
        }).then(() => {
          this.$router.go(-1)
        });
        return
      }
      if (result.data.data.status && result.data.data.goodsList.data.length !== 0) {
        this.goodsData = this.goodsData.concat(result.data.data.goodsList.data)
      } else {
        this.finished = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .activites {
    background: #D23123;
    min-height: 100vh;
  }
</style>
